import React from "react";
import { BASE_URL } from "../../../utils/CONSTANTS";
import { logout } from "../../../utils/msal-utils";

/**
 * ProfileError — shown when SSO sign-in succeeds but the backend cannot match the
 * authenticated identity to an active TTEC Connect employee record
 * (PPORAPIGetLEPService.login returns reason "employee_not_found", i.e. no row on
 * email_work / email / upn). Previously this surfaced as a blank Home page; now the
 * user gets a clear message plus recovery actions.
 *
 * Rendered from a standalone route (see header.js) so it's reachable while SSO tokens
 * are present in localStorage.
 */
export const ProfileError = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#eef4fb",
        padding: 24,
        fontFamily: '"TTEC-Sans","Open Sans",system-ui,sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: 460,
          width: "100%",
          background: "#fff",
          borderRadius: 22,
          boxShadow: "0 30px 70px -28px rgba(1,42,87,.45)",
          padding: "36px 32px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            margin: "0 auto 18px",
            display: "grid",
            placeItems: "center",
            background: "rgba(249,83,111,.12)",
            border: "1.5px solid rgba(249,83,111,.4)",
          }}
        >
          <svg viewBox="0 0 24 24" width="34" height="34" fill="none" style={{ color: "#c8324c" }}>
            <path d="M12 8v5M12 16h.01" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
          </svg>
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 600, color: "#101826", margin: "0 0 8px" }}>
          We couldn&apos;t load your profile
        </h1>
        <p style={{ color: "#455260", fontSize: 14, lineHeight: 1.55, margin: "0 0 22px" }}>
          Your sign-in succeeded, but we couldn&apos;t match your account to a TTEC&nbsp;Connect
          profile. Your record may still be syncing — please try again in a few minutes.
        </p>

        <a
          href={BASE_URL + "api/login"}
          style={{
            display: "block",
            height: 50,
            lineHeight: "50px",
            borderRadius: 13,
            background: "linear-gradient(120deg,#0482df 0%,#0495ff 42%,#3cadff 100%)",
            color: "#fff",
            fontWeight: 600,
            textDecoration: "none",
            marginBottom: 12,
          }}
        >
          Try signing in again
        </a>
        <button
          type="button"
          onClick={() => logout()}
          style={{
            width: "100%",
            height: 48,
            borderRadius: 13,
            background: "#fff",
            border: "1.4px solid rgba(1,42,87,.35)",
            color: "#101826",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Sign out
        </button>

        <p style={{ marginTop: 18, fontSize: 12.5, color: "#7d8aa0" }}>
          Still stuck? Contact{" "}
          <a href="mailto:LouieEXSupport@ttec.com" style={{ color: "#0495ff", fontWeight: 600 }}>
            LouieEXSupport@ttec.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default ProfileError;
